import { ValidationConstruct } from 'vetrf-ui';
import { fileTypes, FileMimeType } from './params';

export const getMimeTypeNames = (types: FileMimeType[]): string[] =>
  types.flatMap((type) => fileTypes.find((t) => t.type === type)?.name || []);

export const getMimeTypeValidation = (
  types: FileMimeType[]
): ValidationConstruct<FileMimeType[]> => ({
  value: types,
  message: `Неверный тип файла, допускаются ${getMimeTypeNames(types).join(', ')}`,
});
